var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4136_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9437 0H4.05634C1.81608 0 0 1.81608 0 4.05634V67.9437C0 70.1839 1.81608 72 4.05634 72H67.9437C70.1839 72 72 70.1839 72 67.9437V4.05634C72 1.81608 70.1839 0 67.9437 0Z",
    fill: "#146EB4",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9437 1.5H4.05634C2.64451 1.5 1.5 2.64451 1.5 4.05634V67.9437C1.5 69.3555 2.64451 70.5 4.05634 70.5H67.9437C69.3555 70.5 70.5 69.3555 70.5 67.9437V4.05634C70.5 2.64451 69.3555 1.5 67.9437 1.5ZM4.05634 0H67.9437C70.1839 0 72 1.81608 72 4.05634V67.9437C72 70.1839 70.1839 72 67.9437 72H4.05634C1.81608 72 0 70.1839 0 67.9437V4.05634C0 1.81608 1.81608 0 4.05634 0Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8922 16C33.4294 16 33.8717 16.4065 33.9283 16.9286L33.9344 17.0422L33.934 18.9H38.3297C39.85 18.9 41.0927 20.0884 41.1795 21.587L41.1844 21.7547V44.2297C41.1844 45.8063 39.9063 47.0844 38.3297 47.0844H15.8547C14.2781 47.0844 13 45.8063 13 44.2297V21.7547C13 20.1781 14.2781 18.9 15.8547 18.9H20.25V17.0422C20.25 16.4666 20.7166 16 21.2922 16C21.8294 16 22.2717 16.4065 22.3283 16.9286L22.3344 17.0422L22.334 18.9H31.85V17.0422C31.85 16.4666 32.3166 16 32.8922 16ZM39.1 29.684H15.084L15.0844 44.2297C15.0844 44.6197 15.3742 44.942 15.7502 44.993L15.8547 45H38.3297C38.7551 45 39.1 44.6551 39.1 44.2297V29.684ZM20.25 20.984L15.8547 20.9844C15.4293 20.9844 15.0844 21.3293 15.0844 21.7547L15.084 27.6H39.1V21.7547C39.1 21.3647 38.8102 21.0424 38.4342 20.9914L38.3297 20.9844L33.934 20.984L33.9344 22.8422C33.9344 23.4178 33.4678 23.8844 32.8922 23.8844C32.355 23.8844 31.9127 23.4779 31.8561 22.9557L31.85 22.8422V20.984H22.334L22.3344 22.8422C22.3344 23.4178 21.8678 23.8844 21.2922 23.8844C20.755 23.8844 20.3127 23.4779 20.2561 22.9557L20.25 22.8422V20.984Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 56H11.5C11.2239 56 11 56.3358 11 56.75C11 57.1642 11.2239 57.5 11.5 57.5H62.5C62.7761 57.5 63 57.1642 63 56.75C63 56.3358 62.7761 56 62.5 56Z",
    fill: "#146EB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4136_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDate);
export default __webpack_public_path__ + "static/media/active-date.0c492060d8ad936dbd88588b415aa7be.svg";
export { ForwardRef as ReactComponent };